import { AxiosError } from 'axios';

import useDownloadExcelFile from '../../../../hooks/queries/multiChannel/useDownloadExcelFile';
import toastMsg from '../../../../lib/toastMsg';
import { DownloadMultiChannelExcelFileRequest } from '../../../../types/multiChannel/orderManagement';
import { asyncSimpleModal } from '../../../../lib/common';
import noticeExcelDownloadResult from '../../../../lib/noticeExcelDownloadResult';
import { convertRequestBody } from '../libs/convertRequestBody';
import { SearchOption } from '../types';

type ExcelDownload = {
  downloadExcelFile: (data: DownloadMultiChannelExcelFileRequest) => Promise<void>;
};

type ExcelDownloadProps = {
  searchOption: SearchOption;
};

const useExcelDownload = ({ searchOption }: ExcelDownloadProps): ExcelDownload => {
  const { mutateAsync } = useDownloadExcelFile();

  const downloadExcelFile = async (data: DownloadMultiChannelExcelFileRequest): Promise<void> => {
    const { type, ids } = data;

    if (type === 'select' && (!ids || ids?.length === 0)) {
      toastMsg.error('선택 된 주문이 없습니다.');
      return;
    }

    try {
      const result = await mutateAsync(convertRequestBody({ ids, searchOption }));

      noticeExcelDownloadResult(result.adminEmail);
    } catch (error: unknown) {
      if (error instanceof AxiosError && error.response?.data.status !== 400) return;
      await asyncSimpleModal({
        type: 'error',
        title: '처리 불가',
        message: '다운로드 할 주문을 불러오던 중 오류가 발생했습니다. 다시 시도해주세요.',
      });
    }
  };

  return {
    downloadExcelFile,
  };
};

export default useExcelDownload;
